<template>
  <div class="dispatchAdd">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">新增核销申请</p>
    </div>
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="inner">
          <van-field
            autocomplete="off"
            v-model="addForm.fittingCategory"
            name="picker"
            label="配件类型"
            placeholder="请填写配件类型"
            required
            readonly
            @click="showPick"
            :rules="[{ required: true, message: '请填写配件类型' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.applyNum"
            name="数量"
            label="数量"
            placeholder="请填写数量"
            required
            type="digit"
            :rules="[{ required: true, message: '请填写数量' }]"
          />
          <van-uploader
            v-model="urls"
            accept="image/*"
            :max-count="3"
            :after-read="afterRead"
            :before-read="beforeRead"
          />
        </div>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择配件类型"
        :columns="portList"
        @confirm="onConfirm"
        @cancel="onCancel"
        value-key="dictLabel"
      />
    </van-popup>
  </div>
</template>

<script>
import { addWorkFit, getDictList, uploadFile } from "@/utils/network/interface";
export default {
  name: "dispatchAdd",
  components: {},
  props: {},
  data() {
    return {
      addForm: {
        applyNum: null,
        csn: "",
        fittingCategory: "",
        urls: [],
      },
      showUnit: false,
      portList: [],
      type: "origin",
      urls: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getDictList();
  },
  mounted() {},
  methods: {
    onSubmit(values) {
      if(!this.urls.length) return this.$toast("请上传图片！")
      this.addForm.urls = this.urls.map(c =>{
        return c.uploadUrl
      })
      addWorkFit(this.addForm).then((res) => {
        if (res.code === 200) {
          // history.go(-1);
          this.$router.push({
            path:'/workOrder/parts',
            query:{
              active:1
            }
          })
        } else {
        }
      });
    },
    getDictList() {
      getDictList().then((res) => {
        // res.data.map(c =>{
        //   let obj = {
        //     label:c.labdictLabell,
        //   }
        //   this.portList.push(obj)
        // })
        this.portList = res.data;
      });
    },
    showPick(type) {
      // this.type = type
      this.$nextTick(() => {
        this.showUnit = true;
      });
    },
    onConfirm(value, index) {
      console.log(value);
      this.addForm.fittingCategory = value.dictLabel;
      this.showUnit = false;
    },
    onCancel() {
      this.showUnit = false;
    },
    onClickBack() {
      // this.$router.go(-1);
      this.$router.push({
        path:'/workOrder/parts',
        query:{
          active:1
        }
      })
    },
    isOverSize(file) {
      const maxSize = 3 * 1024;
      return file.size >= maxSize;
    },
    beforeRead(file) {
      let type =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/JPG" ||
        file.type == "image/JPEG";
      console.log(type, file.type);
      if (!type) {
        this.$toast("请上传格式正确的图片！");
        return false;
      }
      return true;
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      uploadFile(formData).then((res) => {
        if(res.code == 200){
          file.status = 'done';
          file.message = '';
          file.uploadUrl = res.url
        }else{
          file.status = 'failed';
          file.message = '上传失败';
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchAdd {
  // padding: 10px;
  background-color: #eee;
  min-height: 100vh;
  .nav {
    display: flex;
    background: #44b1f9;
    padding: 20px;
    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }
    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }
  }
  .form {
    padding: 10px;
    .inner {
      background-color: #fff;
      padding: 10px;
    }
  }
}
</style>
